var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6161 27.9074C4.34099 26.2777 -0.256513 20.4499 0.0111083 13.6196C0.294707 6.25796 6.25828 0.294386 13.6199 0.0107871C20.4502 -0.25284 26.278 4.34466 27.9077 10.6158C28.375 12.4212 27.009 14.1828 25.1436 14.1828H25.1316C23.8215 14.1828 22.699 13.284 22.3635 12.0178C21.3649 8.25514 17.8379 5.51101 13.7197 5.7307C9.4298 5.95838 5.9587 9.42948 5.73102 13.7194C5.51133 17.8376 8.25546 21.3646 12.0141 22.3592C13.2804 22.6947 14.1791 23.8171 14.1791 25.1273V25.1393C14.1791 27.0046 12.4176 28.3747 10.6161 27.9074Z",
    fill: "#194440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4694 14.6661C17.2496 14.6661 18.6928 13.2229 18.6928 11.4427C18.6928 9.66242 17.2496 8.21924 15.4694 8.21924C13.6891 8.21924 12.2459 9.66242 12.2459 11.4427C12.2459 13.2229 13.6891 14.6661 15.4694 14.6661Z",
    fill: "#194440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.ee29aa9e504a5f84494065db3cc6d2d4.svg";
export { ForwardRef as ReactComponent };